module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d12e80"
    }
  }, [_c('img', {
    attrs: {
      "alt": "0310252342_content_0005_007",
      "id": "d12e81",
      "src": "images/0310252342_content_0005_007.jpg"
    }
  }), _c('b', [_vm._v("To June Jordan ")]), _c('img', {
    attrs: {
      "alt": "0310252342_content_0005_007",
      "id": "d12e85",
      "src": "images/0310252342_content_0005_007.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extc",
    attrs: {
      "id": "d12e86"
    }
  }, [_c('i', [_vm._v("The world is short of virtuous women,"), _c('br'), _vm._v("but there are a few left. You,"), _c('br'), _vm._v("June, are one of those"), _c('br'), _vm._v("wonderful examples of what"), _c('br'), _vm._v("a wife and mot her should be!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-433f3711","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Morr_9780310252344_epub_c2y_r1.vue
// module id = 69
// module chunks = 0